import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import NavBar from "../../components/NavBar";
import NavBarItem from "../../components/NavBarItem";
import { routes } from "../../constants/routes";
import { Activity, checkUserActivity } from "../../helpers/userActivity";
import { Footer } from "./Footer";

import logoPrzelewy24 from "../../../assets/logo-przelewy-24.svg";

/**
 * Menu boczne głównej strony
 */
class Sidebar extends React.Component {

    render() {

        return (

            <div className="w3-sidebar">
                <NavBar className="w3-bar-block w3-small w3-center">
                    <NavBarItem isVisible={checkUserActivity(this.props.authenticatedUser, Activity.NAV_HOME)} url={routes.HOME}>
                        <i className="fa fa-home w3-xxlarge" />
                        <p><FormattedMessage
                            id="app.homePage.title"
                            defaultMessage="Home page"
                        /></p>
                    </NavBarItem>
                    <NavBarItem isVisible={checkUserActivity(this.props.authenticatedUser, Activity.NAV_SETTINGS)} url={routes.SETTINGS}>
                        <i className="fas fa-cogs w3-xxlarge" />
                        <p><FormattedMessage
                            id="app.settingsPage.title"
                            defaultMessage="Settings page"
                        /></p>
                    </NavBarItem>
                    <NavBarItem isVisible={checkUserActivity(this.props.authenticatedUser, Activity.NAV_LIST_USERS)} url={routes.USERS}>
                        <i className="fa fa-users w3-xxlarge" />
                        <p>
                            <FormattedMessage
                                id="app.userPage.title"
                                defaultMessage="User page"
                            />
                        </p>
                    </NavBarItem>
                    <NavBarItem isVisible={checkUserActivity(this.props.authenticatedUser, Activity.NAV_LIST_RESTAURANTS)} url={routes.RESTAURANTS}>
                        <i className="fa fa-utensils w3-xxlarge" />
                        <p>
                            <FormattedMessage
                                id="app.restaurantPage.title"
                                defaultMessage="Restaurant page"
                            />
                        </p>
                    </NavBarItem>
                    <NavBarItem isVisible={checkUserActivity(this.props.authenticatedUser, Activity.NAV_LIST_NETWORKS)} url={routes.NETWORKS}>
                        <i className="fa fa-wifi w3-xxlarge" />
                        <p>
                            <FormattedMessage
                                id="app.networkPage.title"
                                defaultMessage="Network page"
                            />
                        </p>
                    </NavBarItem>
                    <NavBarItem isVisible={checkUserActivity(this.props.authenticatedUser, Activity.NAV_LIST_CONNECTIONS)} url={routes.CONNECTIONS}>
                        <i className="fa fa-network-wired w3-xxlarge" />
                        <p>
                            <FormattedMessage
                                id="app.connectionPage.title"
                                defaultMessage="Connection page"
                            />
                        </p>
                    </NavBarItem>
                    <NavBarItem isVisible={checkUserActivity(this.props.authenticatedUser, Activity.NAV_LIST_TRANSACTIONS)} url={routes.P24_TRANSACTIONS}>
                        <p>
                            <img className="w3-xxlarge" src={logoPrzelewy24} alt='Przelewy24' />
                        </p>
                    </NavBarItem>
                </NavBar>
                <Footer />
            </div>

        )
    }
}

const mapStateToProps = state => {
    return {
        authenticatedUser: state.authReducer.authenticatedUser
    };
};

const mapDispatchToProps = dispatch => {
    return {

    };
};

export default connect(
    mapStateToProps, mapDispatchToProps
)(Sidebar);